var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('finance-info', {
    attrs: {
      "detail": _vm.detail,
      "nativeRegisteredAddress": _vm.nativeRegisteredAddress,
      "country": "Malaysia"
    }
  }), _vm.detail.businessType == 'COMPANY_INCORPORATION' ? [_c('shareholders-info', {
    staticClass: "mt40",
    attrs: {
      "companyMemberList": _vm.detail.companyMemberList,
      "businessType": _vm.detail.businessType
    }
  }), _c('extra-info', {
    attrs: {
      "detail": _vm.detail,
      "nativeRegisteredAddress": _vm.nativeRegisteredAddress,
      "country": "Malaysia"
    }
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }